import { getApi } from '@BUP/services/Axios'

export const fetchAll = (sociogramId) => async () => {
  const client = await getApi('sociogram', { authenticated: true })
  return client
    .get(`/type-survey-configs?sociograms=${sociogramId}`)
    .then(response => response.data)
}